var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScoreCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M8 15.5c4.125 0 7.5-3.375 7.5-7.5 0-.25888-.2099-.46875-.4687-.46875-.2589 0-.4688.20987-.4688.46875 0 3.6094-2.9531 6.5625-6.5625 6.5625-3.60937 0-6.5625-2.9531-6.5625-6.5625 0-3.60937 2.95312-6.5625 6.5625-6.5625.25888 0 .46875-.20987.46875-.46875C8.46875.709867 8.25888.5 8 .5 3.875.5.5 3.875.5 8s3.375 7.5 7.5 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M15.5 8C15.5 3.875 12.125.5 8 .5c-.25888 0-.46875.209867-.46875.46875 0 .25888.20987.46875.46875.46875 3.6094 0 6.5625 2.95312 6.5625 6.5625 0 3.6094-2.9531 6.5625-6.5625 6.5625-3.60938 0-6.5625-2.9531-6.5625-6.5625 0-.25888-.20987-.46875-.46875-.46875C.709867 7.53125.5 7.74112.5 8c0 4.125 3.375 7.5 7.5 7.5s7.5-3.375 7.5-7.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardIcon);
export default __webpack_public_path__ + "static/media/score-card-icon.7d86e350.svg";
export { ForwardRef as ReactComponent };